import { Component } from '@angular/core';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MembreEmplacement } from 'src/app/entites/membre-emplacement';


@Component({
  selector: 'app-modifier-attributs-membre-emplacement',
  templateUrl: './modifier-attributs-membre-emplacement.component.html'
})
export class ModifierAttributsMembreEmplacementComponent {
  membre: MembreEmplacement;
  
  constructor(
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef
  ) {
    this.membre = JSON.parse(JSON.stringify(this.config.data.membre));
  }

  modifier() {
    this.ref.close(this.membre);
  }

  annuler() {
    this.ref.close();
  }
}
